import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const ThreeDotTwoDotThree = () => {
  return (
    <ChangelogInstance version="3.2.3" date="2024-12-08">
      <li>
        Fixed inventory features sometimes breaking
      </li>
    </ChangelogInstance>
  );
}

export default ThreeDotTwoDotThree;